import React from "react";
import "./CustomDevelopmentSystemDefinition.css";

import customDevelopmentSystemDefinitionLuminousBackground from "../../images/custom-development-system-definition-luminous-background.svg";
import customDevelopmentSystemDefinitionConnectedOperatingModelDesktop from "../../images/custom-development-system-definition-connected-operating-model-desktop.svg";
import customDevelopmentSystemDefinitionConnectedOperatingModelMobile from "../../images/custom-development-system-definition-connected-operating-model-mobile.svg";

const customDevelopmentSystemDefinitionPrinciples = [
  { number: "01", title: "Built for the process", body: "The system follows the work — not the other way around.", tone: "blue" },
  { number: "02", title: "Intelligence in the workflow", body: "Automation supports evidence, decisions and control.", tone: "pink" },
  { number: "03", title: "Measured by outcomes", body: "Value is tracked through productivity, visibility and performance.", tone: "green" },
];

export default function CustomDevelopmentSystemDefinition() {
  return (
    <section className="custom-development-system-definition" id="custom-development-what-we-build" aria-labelledby="custom-development-system-definition-title">
      <img className="custom-development-system-definition__background" src={customDevelopmentSystemDefinitionLuminousBackground} alt="" aria-hidden="true" />
      <div className="custom-development-system-definition__inner">
        <div className="custom-development-system-definition__copy">
          <p className="custom-development-system-definition__eyebrow">What we mean by custom</p>
          <h2 id="custom-development-system-definition-title">One connected system, built around the work.</h2>
          <p className="custom-development-system-definition__body">A custom intelligent system connects your data, workflow, controls and decisions in one operational environment.</p>
        </div>
        <picture className="custom-development-system-definition__visual">
          <source media="(max-width: 699px)" srcSet={customDevelopmentSystemDefinitionConnectedOperatingModelMobile} />
          <img src={customDevelopmentSystemDefinitionConnectedOperatingModelDesktop} alt="People, process and data connected through an intelligence layer to automation, decisions and live operational visibility." />
        </picture>
        <div className="custom-development-system-definition__principles">
          {customDevelopmentSystemDefinitionPrinciples.map((principle) => (
            <article className={`custom-development-system-definition__principle custom-development-system-definition__principle--${principle.tone}`} key={principle.number}>
              <span>{principle.number}</span><h3>{principle.title}</h3><p>{principle.body}</p>
            </article>
          ))}
        </div>
        <p className="custom-development-system-definition__statement"><span aria-hidden="true" />One operation · One source of truth · One system designed for the work</p>
      </div>
    </section>
  );
}
